import React, { Component } from 'react';
import '../styles/loading.css'

class Loading extends Component {
    render() {
        return (
            <div style={{ padding: "12px" }} className="edb-center edb-margin-large-top edb-margin-large-bottom">
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                {this.props.text && <div >{this.props.text}</div>}
            </div>
        )
    }
}

export default Loading